import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  appPageTable: {
    position: "relative"
  },
  appPageTableHeader: {
    top: 202,
    [theme.breakpoints.up("sm")]: {
      borderLeft: "1px solid #eeeeee"
    },
    [theme.breakpoints.down("xs")]: {
      top: 194
    },
    [theme.breakpoints.down(Breakpoints.SS_320)]: {
      top: 238
    }
  },
  appPageTableContent: {
    position: "relative",
    display: "flex",
    flexDirection: "column"
  },
  refetchingOverlay: {
    backgroundColor: "rgba(255, 255, 255, 0.5)"
  },
  infiniteLoader: {
    position: "absolute",
    width: 90,
    height: 80,
    margin: "0 auto",
    left: "calc(50% - 40px)"
  },
  showInfiniteLoader: {
    bottom: 20
  },
  showOverlayLoader: {
    position: "absolute",
    display: "flex",
    maxWidth: "100%",
    width: "100%",
    height: "calc(100vh - 210px)",
    margin: 0,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    paddingTop: "40px",
    backgroundColor: "transparent"
  },
  scrollContainer: {
    position: "relative",
    overflowX: "auto",
    overflowY: "scroll",
    willChange: "transform",
    direction: "ltr",
    "&::-webkit-scrollbar": {
      width: 0
    }
  }
}));
